.message {
  color: var(--cl-text);
  font-size: var(--cl-fs-base);
  line-height: var(--cl-lh-base);
}

.error {
  margin-top: var(--cl-space-2);
  color: var(--cl-red);
  font-size: var(--cl-fs-base);
  line-height: var(--cl-lh-base);
}
